/**
 * O PostgREST corta cada consulta em `max_rows` (1000). Saldos e DRE somam o razão inteiro,
 * então ler só a primeira página deixaria os totais errados sem aviso. Lê página a página
 * até uma página vir curta; um erro em qualquer página aborta (nunca devolve dado parcial).
 */
export async function fetchAllPages<T>(
  fetchPage: (from: number, to: number) => Promise<T[]>,
  pageSize = 1000,
): Promise<T[]> {
  const all: T[] = [];
  for (let from = 0; ; from += pageSize) {
    const page = await fetchPage(from, from + pageSize - 1);
    all.push(...page);
    if (page.length < pageSize) return all;
  }
}
